import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { toEnPath, toFrPath } from '../lib/routes';

export function useLocalizedPath() {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const lp = useCallback(
    (path: string) => (lang === 'en' ? toEnPath(path) : path),
    [lang],
  );

  const toOtherLang = useCallback(
    (currentPath: string) => (lang === 'fr' ? toEnPath(currentPath) : toFrPath(currentPath)),
    [lang],
  );

  return { lp, toOtherLang, lang };
}
